import { useSelector } from "react-redux";
import { selectMobile } from "../../../features/appSlice";
import FinancialDataDesktop from "./FinancialDataDesktop";
import FinancialDataMobile from "./FinancialDataMobile";

const ContractData = ({ navProps }) => {
    const isMobile = useSelector(selectMobile);

    if (isMobile) {
        return <FinancialDataMobile navProps={navProps} />;
    }
    return <FinancialDataDesktop navProps={navProps} />;
};

export default ContractData;
